import { Button, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetch from 'use-http';
import graph3 from 'assets/icons/graphs/graph3.svg';
import { CardOverview, DrawerNewInspection, ImageCarousel } from 'components';
import { InspectionStatus } from 'constants/inspections';
import { IMAGE_CAROUSEL_MAX_IMAGES } from 'constants/media';
import { PermissionType } from 'constants/permissions';
import { useSubscription } from 'hooks';
import { useGlobalSelector } from 'stores';
import { Contesto } from './sections/Contesto';
import { Ispezioni } from './sections/Ispezioni';
import { Servizi } from './sections/Servizi';
import { Sovrastruttura } from './sections/Sovrastruttura';
import { Struttura } from './sections/Struttura';
import { Row } from './TabL1.styles';

const TabL1 = ({
  structure,
  userPermissionOnStructure,
  openDrawerNewInspection,
  setOpenDrawerNewInspection,
}) => {
  /* const [overviewL1, setOverviewL1] = useState() */
  /*  const overviewL1 = null; */
  const { user } = useSubscription();

  const params = useParams();
  const id = params.structureId;
  const inspectionId = params?.inspectionId;
  const { get } = useFetch();
  const { showLoader, hideLoader } = useGlobalSelector();
  const [overviewL1, setOverviewL1] = useState();
  const [open, setOpen] = useState(false);
  const [imagesList, setImagesList] = useState();

  const isOwner =
    structure?.ownerId === user?.id || structure?.ownerId === user?.parent?.id;

  const renderVideo = item => {
    return (
      <div>
        <video controls style={{ width: '400px', height: '130px' }}>
          <source src={item.original}></source>
        </video>
      </div>
    );
  };

  useEffect(() => {
    const handleImages = async () => {
      const resultMedia = await get(`bridges/${id}/overviewImages?level=L1`);

      if (resultMedia?.length > 0) {
        const images = [];
        resultMedia?.map(x => {
          images.push({
            original: x.url,
            originalHeight: '130px',
            renderItem: x.isVideo ? renderVideo : null,
          });
        });

        setImagesList(images);
      }
    };

    const handleL1Data = async () => {
      try {
        showLoader();
        const result = await get(
          inspectionId
            ? `bridges/${id}/overview/L1?inspectionId=${inspectionId}`
            : `bridges/${id}/overview/L1`
        );
        result && setOverviewL1(result);
      } catch (err) {
        console.error('Error in put L0 Data Recap: ', err);
      } finally {
        hideLoader();
      }
    };
    id && handleL1Data().catch(console.error) && handleImages();
  }, [id]);

  const imagesWeb = [
    {
      original: graph3,
      originalHeight: '130px',
    },
    {
      original: graph3,
      originalHeight: '130px',
    },
    {
      original: graph3,
      originalHeight: '130px',
    },
    {
      original: graph3,
      originalHeight: '130px',
    },
    {
      original: graph3,
      originalHeight: '130px',
    },
    {
      original: graph3,
      originalHeight: '130px',
    },
  ];

  return structure?.status !== InspectionStatus.NEW ||
    overviewL1?.hasInspection ? (
    <>
      <CardOverview height="200px" buttonDisabled={true}>
        <div style={{ height: '90%', margin: 'auto 0' }}>
          <ImageCarousel
            items={imagesList?.length > 0 ? imagesList : imagesWeb}
            slidesPerView={IMAGE_CAROUSEL_MAX_IMAGES}
            canClick={imagesList?.length > 0}
            maxWidth={
              imagesList && imagesList?.length <= IMAGE_CAROUSEL_MAX_IMAGES
                ? '250px'
                : 'unset'
            }
          />
        </div>
      </CardOverview>

      <Ispezioni overviewL1={overviewL1} structure={structure} />

      <Contesto overviewL1={overviewL1} structure={structure} />

      <Struttura overviewL1={overviewL1} structure={structure} />

      <Row>
        <Sovrastruttura overviewL1={overviewL1} structure={structure} />
        <Servizi overviewL1={overviewL1} structure={structure} />
      </Row>
    </>
  ) : (
    <>
      <Stack alignItems={'center'}>
        <Typography variant="h3">{`Non sono presenti attività all'interno di questa struttura`}</Typography>
        {userPermissionOnStructure === PermissionType.CanEdit &&
          !overviewL1?.hasInspection && (
            <Button
              onClick={() =>
                setOpenDrawerNewInspection(!openDrawerNewInspection)
              }
              variant="contained"
              color="primary"
              size="small"
              style={{ marginTop: 8 }}
            >
              Nuova attività
            </Button>
          )}
      </Stack>
      <DrawerNewInspection
        open={openDrawerNewInspection}
        setOpen={setOpenDrawerNewInspection}
        isOwner={isOwner}
        l3Access={structure?.l3Access}
      />
    </>
  );
};

export { TabL1 };

TabL1.propTypes = {
  structure: PropTypes.object,
  userPermissionOnStructure: PropTypes.oneOf([
    PermissionType.CanView,
    PermissionType.CanEdit,
  ]),
  openDrawerNewInspection: PropTypes.bool,
  setOpenDrawerNewInspection: PropTypes.func,
};
